module.exports = __webpack_public_path__ + "static/media/plus.f1fb82d6.svg";